import React from 'react';
import PropTypes from 'prop-types';

import DescriptionSet from '../DescriptionSet';

const DescriptionSetRenderer = ({ item }) => (
  <DescriptionSet
    className="col-xl-12 col-lg-12 mt-3"
    descriptionSet={item.description}
  />
);

DescriptionSetRenderer.propTypes = {
  item: PropTypes.object.isRequired,
};

export default DescriptionSetRenderer;
